import React, { Fragment } from 'react';
import headerStyles from './HeaderNew/HeaderStyles';
import { retailerSettingsService } from '../../services/retailer-settings/retailer-settings';

const HeaderNew = () => {
  const headerStyle = retailerSettingsService.getHeaderStyle();
  const s = headerStyles[headerStyle];
  const header = retailerSettingsService.getHeader();
  const banner = retailerSettingsService.getBanner();
  const nav = retailerSettingsService.getNav();

  return (
    <Fragment>
      {banner ? (
        <div className="header-banner" dangerouslySetInnerHTML={{ __html: banner }} />
      ) : null}
      <nav className={`${s.nav_main || ''} header_nav desktop-header-nav`}>
        <div className={`header ${s.header_main || ''}`}>
          <div className={`container ${s.header_content || ''}`}>
            <div
              className={`header-link ${s.header_link || ''} ${s.header_logo_link_container || ''}`}
            >
              <a
                className={`retailer-logo-link ${s.header_logo_container || ''}`}
                href={`${header.target_url || ''}${header.return_tid || ''}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className={`retailer-logo ${s.header_logo || ''}`}
                  src={`${header.desktop_src_2x || ''}`}
                  alt={`${header.alt_text || ''}`}
                />
              </a>
            </div>
            <div className={`nav ${s.header_wrapper || ''}`}>
              <ul className={`${s.header_menu || ''} desktop-header-menu`}>
                {nav.map((item, index) => (
                  <li
                    key={item.label}
                    className={`nav-item nav-${(item.label || '').toLowerCase().replace(/\s/g, '-')} ${s.header_menu_item}`}
                  >
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`header-menu-link header-menu-link-${index} link-${(item.label || '').toLowerCase().replace(/\s/g, '-')} ${s.header_link || ''} ${s.header_menu_item_link || ''}`}
                      href={`${item.href || ''}${item.return_tid || ''}`}
                      data-track={item.tracking_id}
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </Fragment>
  );
};

export default HeaderNew;
